import React, { useState } from 'react'
import { MDBContainer, MDBModal, MDBModalBody, MDBCol, MDBBtn, MDBRow, MDBIcon } from 'mdbreact'
import CategoryBlogs from './CategoryBlogs'
import pageConstruction from '../../../img/page-construction.json'
import Lottie from 'lottie-react-web'
import Loading from '../../loaders/Loading'
import Error from '../../loaders/Error'
import { HashLink as Link } from 'react-router-hash-link';
//graphql 
import { useQuery } from '@apollo/react-hooks';
import GET_BLOGS_BY_CATEGORY from '../../../queries/blog/getBlogsByCategory';
import Navbar from '../../Navbar'
import SEO from '../../SEO'
import FooterWhite from '../../FooterWhite'
import SearchModal from '../SearchModal'

const BlogItem = ({match, history}) => {
    const [ modal, setModal ] = useState(true);
    const [ show, setShow ] = useState(false);

    const { data, loading, error } = useQuery(GET_BLOGS_BY_CATEGORY, { variables: { category: match.params.category } })

    if(loading) return <Loading/>
    if(error) return <Error/>

    const toggle = () => setModal(!modal)
    
    return (
        <>
        <SEO title="Blog Categories" description="A Collection of different categories for the people to choose."/>
        <Navbar show={show} onClick={()=>setShow(!show)} page="Blogs"/>
        <div style={{ display: show ? "none" : "inline" }} className="blog-categories-wrapper">
        <MDBContainer className="my-5 pb-5">
            <h1 style={{ marginBottom: '10%' }} className="h1-responsive text-capitalize font-weight-bold text-center">
                {match.params.category}
            </h1>
            <MDBContainer className="mt-5 mb-5">
                {data.blogs.length === 0 ? (
                    <>
                    <MDBContainer>
                        <MDBModal isOpen={modal} centered>
                            <MDBModalBody>
                            <div className="p-5">
                                <div className="text-center">
                                <div>
                                    <Lottie
                                    options={{
                                        animationData: pageConstruction
                                    }}
                                    />
                                </div>
                                <div className="mt-4">
                                    <p className="grey-text">
                                        There are no blogs published yet at this category, author needs time to publish her blogs.
                                    </p>
                                </div>
                                <div>
                                    <button onClick={()=>{
                                            toggle()
                                            setTimeout(()=>{
                                                history.push('/blogs')
                                            },1150)
                                        }} className="newsletter-subscription-button z-depth-1">I understand</button>
                                </div>
                                </div>
                            </div>
                            </MDBModalBody>
                        </MDBModal>
                    </MDBContainer>
                    </>
                ) :(
                    <>
                    <CategoryBlogs selectedCategory={data.blogs}/>
                    </>
                )}
            </MDBContainer>
        </MDBContainer>
        <MDBContainer fluid className="px-0 pt-5">
            <section className="p-5 grey lighten-4">
                <MDBRow className="py-5 justify-content-center">
                    <MDBCol md="10" lg="8">
                        <div className="text-center">
                            <h2 style={{ lineHeight: 1.5 }} className="h2-responsive font-weight-bold">Request Blog?</h2>
                            <p className="lead">Need a specific content for us? Don't worry we got your back! Give us a call between 10am - 7pm at +63 919 9239 29. We speak English, Tagalog and Cebuano. Just let us know what you need.</p>
                            <Link smooth to="/contact#contact-us">
                                <MDBBtn color="dark" className="text-capitalize">
                                    Send Message <MDBIcon fas icon="arrow-right ml-2"/>
                                </MDBBtn>
                            </Link>
                        </div>
                    </MDBCol>
                </MDBRow>
            </section>
        </MDBContainer>
        <FooterWhite/>
        </div>
        <SearchModal onClick={()=>setShow(false)} show={show}/>
        </>
    )
}

export default BlogItem
